import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList
} from 'graphql'

export interface ApplicationMergeMutationArgs {
  readonly input: {
    readonly organizationID: string
    readonly ids: string[]
    readonly primaryID: string
  }
}

export const applicationMergeMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ApplicationMergeMutationArgs',
      description:
        'Parameters that describe a merge operation for applications',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization for the applicatons being merged',
          type: new GraphQLNonNull(GraphQLID)
        },
        ids: {
          description: 'List of IDs of the applications being merged.',
          type: new GraphQLNonNull(
            new GraphQLList(new GraphQLNonNull(GraphQLID))
          )
        },
        primaryID: {
          description:
            'The ID of the application that will act as the primary application.',
          type: new GraphQLNonNull(GraphQLID)
        }
      })
    })
  }
}
